import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Address = (props) => {
  return (
    <FormGroup controlId="address">
      <Col componentClass={ControlLabel} sm={5}>
        Address
      </Col>
      <Col sm={7}>
        <textarea
          id="address"
          rows="6"
          cols="25"
          maxLength="4000"
          className="form-control"
          value={props.address}
          onChange={props.handleChangeAddress} />
      </Col>
    </FormGroup>
  )
}

Address.propTypes = {
  address: PropTypes.string,
  handleChangeAddress: PropTypes.func
};

export default Address;



// WEBPACK FOOTER //
// ./src/app/components/address/Address.js